import { useMemo, useState } from "react";

import ICarret from "assets/i-carret.js";
import ICheckRounded from "assets/i-check-rounded.js";

const roundAmount = (amount) => {
  if (!amount) return "";

  let temp = amount;

  if (typeof amount !== "number") temp = parseInt(amount);

  return Math.round(temp).toLocaleString("id-ID");
};

const CompanyA = ({ data }) => {
  const [isDetailCPlus, setIsDetailCPlus] = useState(false);
  const FIRST_COMPANY = useMemo(() => {
    const payee = data?.management_fee_invoice;
    const company = data?.company;

    const note = `Bukti Potong PPh 23 harap ditujukan ke ${payee?.payee_company || ""}, paling lambat tgl 20 bulan berikutnya setelah pembayaran dilakukan.`;

    let result = {
      name: payee?.payee_company ? `${payee.payee_company}` : "",
      address:
        "Ciputra World 2 Lt. 7F, Jl. Prof Dr Satrio Kav. 11 Jakarta 12930",
      noInvoice: payee?.invoice_number || "",
      invoiceDate: payee?.invoice_date || "",
      invoiceDueDate: payee?.due_date || "",
      toWhom: company?.legal_name ? `${company.legal_name}` : "",
      officeName: company?.name || "",
      destinationLocation: company?.address?.street || "",
      periode: payee?.invoice_period || "",
      tanggalBayar: payee?.paid_at || "",
      gcc: payee?.management_fee_detail?.gcc_amount
        ? `Rp ${roundAmount(payee.management_fee_detail.gcc_amount)}`
        : "",
      jasaManagementFee:
        payee?.management_fee_detail?.management_fee_rate || "",
      jasaManagement:
        roundAmount(payee?.management_fee_detail?.management_fee_after_cap) ||
        "",
      selfManagedBmf:
        roundAmount(payee?.management_fee_detail?.self_management_bmf_amount) ||
        "",
      jasaManagementNetto:
        roundAmount(payee?.management_fee_detail?.management_fee_net) || "",
      note: note,
      dpp: roundAmount(payee?.tax_base) || "",
      dppNilaiLainPpn: roundAmount(payee?.vat_tax_base) || "",
      ppn: roundAmount(payee?.vat_amount) || "",
      ppnRate: "12",
      // ppnRate: payee?.vat_rate || "",
      pph23: roundAmount(payee?.withholding_tax_amount) || "",
      tabunganAsuransiCp: roundAmount(payee?.insurance_savings_deposit) || "",
      cPlus: payee?.c_plus_details?.map((item) => {
        return {
          idUser: item?.user?.id,
          name: item?.user?.full_name,
          invoice: roundAmount(item?.amount),
        };
      }),
      total: roundAmount(payee?.total_amount) || "",
    };

    return result;
  }, [data]);

  return (
    <div className="bg-[#fff] mb-6 rounded-[4px] border-[0.5px] border-solid border-[#D8D8D9]">
      {/* Header */}
      <div className="px-4 py-2 rounded-t-[4px] bg-[#F5F5F5]">
        <p className="text-[17px] leading-[27.506px] tracking-[-0.4px] font-semibold text-[#252526]">
          {FIRST_COMPANY.name}
        </p>
        <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
          {FIRST_COMPANY.address}
        </p>
      </div>

      {/* Body */}
      <div className="px-4 py-2 rounded-b-[4px]">
        {/* Info Date */}
        <div className="py-2">
          <div className="flex items-center gap-2 mb-1">
            <p className="min-w-[100px] text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
              No. Invoice:
            </p>
            <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
              {FIRST_COMPANY.noInvoice}
            </p>
          </div>
          <div className="flex items-center gap-2 mb-1">
            <p className="min-w-[100px] text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
              Tgl. Invoice: 
            </p>
            <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
              {FIRST_COMPANY.invoiceDate}
            </p>
          </div>
          <div className="flex items-center gap-2 mb-1">
            <p className="min-w-[100px] text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
              {FIRST_COMPANY.tanggalBayar ? `Tanggal Bayar:` : `Jatuh tempo:`}
            </p>
            <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#C61025] flex items-center gap-1">
              {FIRST_COMPANY.tanggalBayar || FIRST_COMPANY.invoiceDueDate} 
              {(FIRST_COMPANY.tanggalBayar) && <ICheckRounded color="#0D814A" />}
            </p>
          </div>
        </div>

        {/* Info To Whom */}
        <div className="py-2">
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            Kepada:
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
            {FIRST_COMPANY.toWhom}
          </p>
          <p className="text-[17px] leading-[27.506px] tracking-[-0.4px] font-semibold text-[#252526]">
            {FIRST_COMPANY.officeName}
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            {FIRST_COMPANY.destinationLocation}
          </p>
        </div>

        {/* Info Periode & GCC */}
        <div className="py-2 flex items-center justify-between">
          <p className="flex items-center gap-2 text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
            Periode:{" "}
            <span className="font-semibold text-white bg-[#BEAF87] px-2 h-6 flex items-center justify-center">
              {FIRST_COMPANY.periode}
            </span>
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
            Gross Closed Commission:{" "}
            <span className="font-semibold">{FIRST_COMPANY.gcc}</span>
          </p>
        </div>

        {/* Info Detail Amount */}
        <div className="py-2">
          <div className="px-4 py-1 flex items-center justify-between rounded-t-[0.5px] bg-[#F5F5F5]">
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              Deskripsi
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              Nominal
            </p>
          </div>
          <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-b-[0.5px] border-solid border-[#D8D8D9]">
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              Management Fee ({FIRST_COMPANY.jasaManagementFee}% x GCC)
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              {FIRST_COMPANY.jasaManagement}
            </p>
          </div>
          <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-b-[0.5px] border-solid border-[#252526]">
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              Self Managed BMF
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              ({FIRST_COMPANY.selfManagedBmf})
            </p>
          </div>
          <div className="px-4 mb-4 py-1 flex items-center justify-between rounded-b-[0.5px]">
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              Nett Management Fee
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              {FIRST_COMPANY.jasaManagementNetto}
            </p>
          </div>

          {/* Table Total */}
          <div className="flex items-start gap-[40px] justify-between">
            <div className="w-[405px]">
              <p className="bg-[#EBF0F7] mb-4 px-4 py-2 text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#3268AE]">
                <span className="font-inter-semibold text-[#3268AE] mr-1">
                  Catatan:
                </span>
                {FIRST_COMPANY.note}
                <br />
                <span className="font-inter-semibold text-[#3268AE] mr-1">
                  NPWP - Sagotra Usaha:
                </span>
                001.747.479.2-011.000
              </p>
              <p className="bg-[#EBF0F7] px-4 py-2 text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#3268AE]">
                <span className="font-inter-semibold text-[#3268AE] mr-1">
                 Rumus Perhitungan C+ Saving:
                </span>
                <br />
                0,891% x Gross Closed Commission (*kecuali terdapat penyesuaian)
              </p>
            </div>
            <div className="w-[calc(100%-405px)]">
              <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-b-[0.5px] border-solid border-[#D8D8D9]">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  DPP (Dasar Pengenaan Pajak)
                </p>
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  {FIRST_COMPANY.dpp}
                </p>
              </div>
              <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-b-[0.5px] border-solid border-[#D8D8D9]">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  DPP Nilai Lain PPN (11%/12%)
                </p>
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  {FIRST_COMPANY.dppNilaiLainPpn}
                </p>
              </div>
              <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-b-[0.5px] border-solid border-[#D8D8D9]">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  PPN ({FIRST_COMPANY.ppnRate}% x DPP Nilai Lain)
                </p>
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  {FIRST_COMPANY.ppn}
                </p>
              </div>
              <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-b-[0.5px] border-solid border-[#D8D8D9]">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  PPh 23 (2% x DPP)
                </p>
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  ({FIRST_COMPANY.pph23})
                </p>
              </div>
              <div className="px-4 py-1 flex items-center justify-between">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  C+ Saving{" "}
                  <span className="text-[#808285]">
                    ({FIRST_COMPANY?.cPlus?.length} marketing)
                  </span>
                </p>
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  {FIRST_COMPANY?.tabunganAsuransiCp}
                </p>
              </div>

              <div className="px-4">
                <div className="px-2 py-1 flex items-center justify-between rounded-t-[0.5px] bg-[#F5F5F5]">
                  <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                    Lihat Detail C+
                  </p>

                  <button
                    onClick={() => setIsDetailCPlus(!isDetailCPlus)}
                    className={isDetailCPlus ? "rotate-180" : ""}
                  >
                    <ICarret className="rotate-90" />
                  </button>
                </div>
                {isDetailCPlus && (
                  <>
                    <div className="px-2 py-1 grid grid-cols-3">
                      <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                        ID User
                      </p>
                      <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                        Nama
                      </p>
                      <p className="text-end text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                        Tagihan
                      </p>
                    </div>
                    {FIRST_COMPANY?.cPlus?.map((item, index) => (
                      <div className="px-2 py-1 grid grid-cols-3">
                        <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                          {item.idUser}
                        </p>
                        <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#252526]">
                          {item.name}
                        </p>
                        <p className="text-end text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#252526]">
                          {item.invoice}
                        </p>
                      </div>
                    ))}
                  </>
                )}
              </div>

              <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-t-[0.5px] border-solid border-[#252526]">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#252526]">
                  Netto
                </p>
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#252526]">
                  {FIRST_COMPANY.total}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyA;
